// extracted by mini-css-extract-plugin
export default {"columns":"RyZrnT","column":"Pijgjb","badge":"RaY7m9"};